import React, { Fragment } from 'react';
import { get } from 'lodash';
import { PathologyAlertResult } from '../../../components/DataMapper/type';
// @ts-ignore
import ArrowDownRed from '../../../../assets/img/ArrowDownRed.svg';
// @ts-ignore
import ArrowUpRed from '../../../../assets/img/ArrowUpRed.svg';
// @ts-ignore
import DoubleUp from '../../../../assets/img/DoubleUp.svg';
import ReactTooltip from 'react-tooltip';
import type { ObservationValue } from '../types';

interface ObservationTableProps {
  observationData: ObservationValue[];
}

type ObservationRowProps = {
  name: string;
  values: any[];
  interpretations: any[] | null;
  units: any[] | null;
  ranges: any[] | null;
};

const ObservationItem = ({
  item,
  interpretation,
  index,
  unit,
  range,
}: {
  item: string;
  interpretation: any;
  index: number;
  unit: string;
  range: any;
}) => {
  const interpretationCode = get(interpretation, '[0].coding[0].code', null);
  const isAlert =
    interpretationCode === PathologyAlertResult.High ||
    interpretationCode === PathologyAlertResult.Low ||
    interpretationCode === PathologyAlertResult.AbnormalAlert;
  const lowRange = get(range, '[0].low.value', '');
  const highRange = get(range, '[0].high.value', '');
  const hoverData = item
    ? `${item} [${lowRange}${lowRange ? ' ' : ''}${lowRange && highRange ? '- ' : ''}${highRange}${highRange ? ' ' : ''}${unit}]`
    : '';
  return (
    <Fragment>
      <div
        data-tip
        data-for={`observation-${item}-${index}`}
        className={isAlert ? 'text-danger' : ''}
      >
        {item}
        {interpretationCode === PathologyAlertResult.AbnormalAlert && (
          <img src={DoubleUp} alt="alert" />
        )}
        {interpretationCode === PathologyAlertResult.High && (
          <img src={ArrowUpRed} alt="high" />
        )}
        {interpretationCode === PathologyAlertResult.Low && (
          <img src={ArrowDownRed} alt="low" />
        )}
      </div>
      {hoverData ? (
        <ReactTooltip
          id={`observation-${item}-${index}`}
          place="bottom"
          type="dark"
          effect="float"
        >
          {hoverData}
        </ReactTooltip>
      ) : null}
    </Fragment>
  );
};

const ObservationRow = ({
  name,
  values,
  interpretations = null,
  units = null,
  ranges = null,
}: ObservationRowProps) => {
  return (
    <div className="d-flex flex-row gap-2 height-50">
      <span className="w-25 roboto font-13 d-flex align-items-center ">
        {name}
      </span>
      <div className="d-flex flex-row w-75 justify-content-evenly align-items-center">
        {values.map((item: any, index: number) => (
          <div
            key={`observation-${name}-${index}`}
            className={
              'd-flex w-100 roboto font-13 text-center border-1 border-bottom h-100 justify-content-center align-items-center' +
              (index === values.length - 1 ? '' : ' border-end')
            }
          >
            <ObservationItem
              item={item}
              interpretation={interpretations?.[index]}
              index={index}
              unit={units?.[index]}
              range={ranges?.[index]}
            />
          </div>
        ))}
      </div>
    </div>
  );
};
const ObservationTable = ({ observationData }: ObservationTableProps) => {
  return observationData.map((observation) => (
    <ObservationRow
      key={observation.name}
      name={observation.name}
      values={observation.values}
      interpretations={observation.interpretations}
      units={observation.units}
      ranges={observation.ranges}
    />
  ));
};

export default ObservationTable;
